import { observeFilteredThreadEntriesForVirtualList } from "~/components/content-list/ThreadEntry";
import { useInitialQueryLimit } from "./useInitialQueryLimit";
import { useRecordLoader } from "./useRecordLoader";

export function useTrashViewThreadIds() {
  const initialLimit = useInitialQueryLimit(100);

  return useRecordLoader({
    name: "useTrashViewThreadIds",
    load({ loader, limit, currentUserId }) {
      const observable = loader.observeGetTrashViewThreads({ currentUserId, limit, sortDirection: "DESC" });

      return observeFilteredThreadEntriesForVirtualList({ recordLoader: loader }, observable);
    },
    initialLimit,
    limitStep: initialLimit,
    map: (records) => records.map((r) => r.id),
  });
}
